(() => {
  function enhanceSizeOptions(main) {
    main.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
      const legend = fieldset.querySelector('legend');
      if (!legend?.textContent.includes('サイズ')) return;

      fieldset.classList.add('bt-size-fieldset', 'bt-size-options');

      fieldset.querySelectorAll('label.variant__label:not(.color-img__label)').forEach((label) => {
        if (label.dataset.btSizeEnhanced === 'true') return;

        const unavailableMessage = label.querySelector('.visually-hidden')?.textContent.trim() || '';
        const value = (label.control?.value || label.textContent).replace(/\s+/g, '').trim();
        let range = value;
        let note = '';

        if (value.includes('38mm/40mm/41mm/42mm')) {
          range = '38・40・41・42mm';
          note = '42mmはSeries 10 / 11';
        } else if (value.includes('42mm/44mm/45mm/46mm/49mm')) {
          range = '42・44・45・46・49mm';
          note = '42mmはSeries 1 / 2 / 3';
        }

        label.replaceChildren();

        const rangeElement = document.createElement('span');
        rangeElement.className = 'bt-size-option__range';
        rangeElement.textContent = range;
        label.append(rangeElement);

        if (note) {
          const noteElement = document.createElement('span');
          noteElement.className = 'bt-size-option__note';
          noteElement.textContent = note;
          label.append(noteElement);
        }

        if (unavailableMessage) {
          const unavailableElement = document.createElement('span');
          unavailableElement.className = 'visually-hidden';
          unavailableElement.textContent = unavailableMessage;
          label.append(unavailableElement);
        }

        label.dataset.btSizeEnhanced = 'true';
      });
    });
  }

  function syncVariantDeliveryCopy(main) {
    const backorderPanel = main.querySelector('[data-bt-backorder-delivery]');
    if (!backorderPanel) return;

    const isBackorder = !backorderPanel.hidden;

    main.querySelectorAll('[data-bt-variant-delivery-heading]').forEach((heading) => {
      const text = isBackorder ? 'お取り寄せ商品' : '即納商品';
      if (heading.textContent.trim() !== text) heading.textContent = text;
    });

    main.querySelectorAll('[data-bt-variant-instant-copy]').forEach((element) => {
      if (element.hidden !== isBackorder) element.hidden = isBackorder;
    });

    main.querySelectorAll('[data-bt-variant-backorder-copy]').forEach((element) => {
      if (element.hidden === isBackorder) element.hidden = !isBackorder;
    });
  }

  function enhanceProductUi(root = document) {
    root.querySelectorAll('product-info[id^="MainProduct-"]').forEach((main) => {
      enhanceSizeOptions(main);
      syncVariantDeliveryCopy(main);

      main.querySelectorAll('.product-form__buttons').forEach((buttons) => {
        buttons.classList.add('bt-product-buttons');

        [...buttons.children].forEach((child) => {
          if (child.id === 'bogos-pa-upsell-view') child.classList.add('bt-product-bundle');
          if (
            child.textContent.includes('eギフト') &&
            !child.matches('.product-form__submit, .shopify-payment-button, #bogos-pa-upsell-view')
          ) {
            child.classList.add('bt-product-egift');
          }
        });
      });

      if (main.dataset.btCommonObserver === 'true') return;
      main.dataset.btCommonObserver = 'true';

      let scheduled = false;
      new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(() => {
          scheduled = false;
          enhanceProductUi(main.parentElement || document);
        });
      }).observe(main, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden']
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceProductUi(), { once: true });
  } else {
    enhanceProductUi();
  }

  document.addEventListener('shopify:section:load', (event) => enhanceProductUi(event.target));
  document.addEventListener('variant:change', () => enhanceProductUi());
})();
